import { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import PhotoCapture from "@/components/gate/PhotoCapture";

// Step 2 of a pass scan: confirm vehicle, take photo, enter km for test rides.
export default function GateCapture({ lookup, onDone, onCancel }) {
  const p = lookup.pass;
  const isRide = p.kind === "test_ride";
  const [photo, setPhoto] = useState(null);
  const [km, setKm] = useState("");
  const [busy, setBusy] = useState(false);
  const label = lookup.next_action === "exit" ? "Record EXIT" : "Record RETURN";
  const ready = photo && (!isRide || km !== "");

  const submit = async () => {
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("token", p.token);
      fd.append("photo", photo);
      if (isRide) fd.append("odometer_km", km);
      const { data } = await api.post("/gate-passes/scan", fd);
      onDone({ ok: true, ...data });
    } catch (err) {
      onDone({ ok: false, error: formatApiError(err) });
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="border-2 border-ink bg-canvas-card p-4 space-y-3" data-testid="gate-capture">
      <div className="flex justify-between items-start">
        <div>
          <div className={`inline-block px-2 py-0.5 text-[10px] font-bold text-white ${isRide ? "bg-[#b45309]" : "bg-[#047857]"}`}>
            {isRide ? "TEST RIDE" : "CUSTOMER EXIT"} · {lookup.next_action.toUpperCase()}
          </div>
          <div className="font-mono text-sm mt-1">{p.pass_no}</div>
        </div>
        <button type="button" onClick={onCancel} data-testid="gate-capture-cancel" className="text-xs underline text-ink-muted">Cancel</button>
      </div>
      <div className="text-2xl font-bold tracking-wide" data-testid="gate-capture-vehicle">{p.vehicle_reg_no || "—"}</div>
      <div className="text-sm text-ink-muted">{isRide ? `Technician: ${p.technician}` : p.customer_name}</div>
      {isRide && lookup.next_action === "return" && p.exit_odometer_km != null && (
        <div className="text-xs font-mono">Exit km: {p.exit_odometer_km} · out {p.minutes_out} min</div>
      )}
      <PhotoCapture value={photo} onChange={setPhoto} />
      {isRide && (
        <input type="number" inputMode="numeric" value={km} onChange={(e) => setKm(e.target.value)}
          placeholder="Odometer reading (km) — required" data-testid="gate-odometer-input"
          className="w-full px-3 py-3 border border-canvas-line text-base" />
      )}
      <button type="button" onClick={submit} disabled={!ready || busy} data-testid="gate-capture-submit"
        className="w-full py-4 bg-ink text-white font-bold text-base disabled:opacity-40">
        {busy ? "Saving…" : label}
      </button>
    </div>
  );
}
